import React, { Component } from 'react';

import AGenerateModel from 'components/generic/AGenerateModel';

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";



import * as commonFunc from 'scripts/common';

import { withRouter } from 'components/withRouter';

class ManageNotifications extends Component {
    static displayName = ManageNotifications.name;

    static models;

    constructor(props) {
        super(props);

        this.notifGen = React.createRef(null);

        this.state = { };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {
            context.getContent();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.searchParams !== prevProps.searchParams) {
            this.getContent();
        }
    }

    getContent() {
        this.setState({ config: null, modelsList: null });
        var context = this;

        //TEMP >> (GetCustom sur les categs en IsNotif=true)
        //commonFunc.getMethod("../api/site/GetSiteModels", { id: -1, categ: "SITES" }).then((responseModel) => {
        //commonFunc.getMethod("../api/site/GetSiteModelsList", { id: -1, categ: "SITES" }).then((responseModel) => {
        commonFunc.getMethod("../api/data/GetAllModels", { filter: "site", categ: "SITES", useParentSite: true, excludeMode: 1 }).then((responseModel) => {
            var dataModel = responseModel.data;
            if (dataModel.isSuccess && dataModel.result) {// && dataModel.result.models
                //var customConfig = JSON.parse(dataModel.result);

                var customConfig;
                //var filteredModels = dataModel.result.filter((model) => model.extID === "NOTIF");//dataModel.result.models
                var filteredModels = dataModel.result.map(keyItem => keyItem.tag).filter((model) => model.extID === "NOTIF");//dataModel.result.models
                if (filteredModels?.length) {
                    customConfig = JSON.parse(filteredModels[0].value);
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModel")
                    });
                }
                var customModels = {};
                //dataModel.result.forEach((model) => {//dataModel.result.models
                dataModel.result.map(keyItem => keyItem.tag).forEach((model) => {//dataModel.result.models
                    customModels[model.extID] = JSON.parse(model.value);
                });
                    
                this.setState({ config: customConfig, modelsList: customModels });
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadModel") + " :<br>" + dataModel.errorMessage
                });
            }
        });
    }

    render() {
        return this.state.config ? (
            <div className="notifModule">
                <AGenerateModel ref={this.props.notifGen} parentProps={{ type: "custom", dataCfg: this.props.dataCfg }} noButtons modelsList={this.state.modelsList} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} getUser={this.props.getUser} configModel={this.state.config} />
            </div>
        ) : <div>{this.props.i18nManager.t("gal_loadingModule")}</div>;
    }

}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageNotifications));